var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modo)?_c('span',{staticClass:"produto-restricao produto-modo-pedido",class:[`produto-modo-pedido-${_vm.modo.id}`, {'produto-modo-pedido-sacola': _vm.variant === 'sacola'}]},[_vm._v(" "+_vm._s(_vm.modo.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }